import { DataAttributeDefinitions } from 'scrivito'

import { pisaTimerecordDescriptionDataClass } from './Pisa/pisaTimerecordDescriptionDataClass'

const attributes: DataAttributeDefinitions = {}

export const TimerecordDescription =
  pisaTimerecordDescriptionDataClass(attributes)
